import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class OccurrenceTypeList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      // user: {},
      // updated: false,
      // searched: false,
      loading: true
    };

    this.error = this.error.bind(this);
    this.insertNotice = this.insertNotice.bind(this);
    this.deleteNotice = this.deleteNotice.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  insertNotice() {
    this.props.history.push("/occurrence_type/form");
  }

  deleteNotice(dropRowKeys) {
    dropRowKeys.forEach(key => {
      axios
        .post(`${URL.api}communication/occurrence_type/delete/${key}`, null, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          // eslint-disable-next-line react/no-access-state-in-setstate
          let newList = [...this.state.list];
          // let index;
          for (let i = 0; i < newList.length; i++) {
            if (newList[i].id === key) {
              // index = i;
              newList.splice(i, 1);
              break;
            }
          }
          // newList.splice(index, 1);
          this.setState(
            {
              list: newList
            },
            () => {
              this.forceUpdate();
            }
          );
        });
    });
  }

  componentDidMount() {
    const params = {
      user_id: this.props.user.id,
      group_id: this.props.general.active_roles.group_id
    };

    axios
      .get(`${URL.api}communication/occurrence_type/list`, {
        params,
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        resp.data.data.filter((item, id) => {
          const currentDate = new Date(item.created_at);
          const date = currentDate.getDate();
          const month = currentDate.getMonth();
          const year = currentDate.getFullYear();
          const hour = currentDate.getHours();
          const minutes = currentDate.getMinutes();

          const dateString = `${date}/${
            month + 1
          }/${year} - ${hour}:${minutes}`;
          item.created_at = dateString;
        });

        this.setState({ list: resp.data.data, loading: false });
      });
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Breadcrumb current={this.props.currentRoute} />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            {this.state.list ? (
              <div id="list">
                <DataTable
                  list={this.state.list}
                  path="/occurrence_type/edit/"
                  title="Lista de Tipos de Ocorrências"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "code", denomination: "Código" },
                    { name: "description", denomination: "Descrição" }
                  ]}
                  insert
                  delete
                  insertAction={this.insertNotice}
                  deleteAction={this.deleteNotice}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OccurrenceTypeList);
